export default __webpack_public_path__ + "static/media/Experience_GalleryFirst.e0cd3b02.jpg";